var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"routeContainer"},_vm._l((_vm.vakken),function(vak){return _c('div',{key:vak},[_c('router-link',{attrs:{"to":`/strijkService/${vak.toLowerCase().replace(' ', '_')}`}},[_c('ExploreComponent',{attrs:{"vak":vak}})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }